import React, { useEffect, useState } from "react";
import "./CartProductCard.css";
import {
  faAngleRight,
  faArrowRight,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "react-bootstrap";
import { deleteAllCart, getAllCart } from "../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import IncrementDecrementBtnCart from "../../common_components/common_btn/Increment_Decrement_Btn_Cart/IncrementDecrementBtnCart";
import { encodeId, variant_type } from "../../../utils/common";
import { useNavigate } from "react-router-dom";

const CartProductCard = ({ mrp, price, saveTotal, customClass, ...props }) => {
  const allCart = useSelector((state) => state.cart.allCarts);
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteData, setDeleteData] = useState({
    id: null,
    product_id: null,
    variant_id: null,
  });

  const openDeleteModal = (id, product_id, variant_id) => {
    setDeleteData({
      id,
      product_id,
      variant_id,
    });

    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    await deleteCart(
      deleteData.id,
      deleteData.product_id,
      deleteData.variant_id,
    );

    setShowDeleteModal(false);
  };

  // useEffect(() => {
  //     dispatch(getAllCart(isSignIn));
  // }, []);

  const deleteCart = async (id, product_id, varient_id) => {
    const res = await dispatch(
      deleteAllCart({ id, isSignIn, product_id, varient_id }),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllCart(isSignIn));
    } else if (res.meta?.requestStatus === "rejected") {
      // console.log("Error:", res.payload || "Not In Cart");
    }
  };

  const navigate = useNavigate();
  return (
    <div className="CartProductCard">
      <div className="product_content">
        <div className="product_detail_inner">
          <div className="row row_class">
            <div className="col-xl-7 col-lg-7 col-md-6 col-sm-4 col-12">
              <div className="left_side">
                <div
                  className="img_holder"
                  onClick={() =>
                    navigate(`/product-description/${encodeId(props?.cartVarient?.Product?.id)}`)
                  }
                >
                  <img
                    src={
                      process.env.REACT_APP_IMG_URL +
                      props?.cartVarient?.Product?.image
                    }
                  />
                </div>

                <div className="text_holder">
                  <div className="product_name">
                    <p>{props?.cartVarient?.Product?.name}</p>
                  </div>
                  {/* <div className="weight">
                    <p>
                      Thickness :{" "}
                      {props?.cartVarient?.Triple_Variant?.Diamond?.name}
                    </p>
                    <p>
                      Type:{" "}
                      {
                        props?.cartVarient?.Triple_Variant?.Double_Variant
                          ?.Product_Variant?.Size?.name
                      }
                    </p>
                    <p>
                      Size :{" "}
                      {
                        props?.cartVarient?.Triple_Variant?.Double_Variant?.Product_Variant?.Diamond
                          ?.name
                      }
                    </p>
                  </div> */}
                  <h6>
                    {props?.cartVarient?.Product?.variant_type_id ===
                      variant_type.Single && (
                      <>
                        <strong>Type:</strong>{" "}
                        {props?.cartVarient?.Product_Variant?.Metal?.name}
                      </>
                    )}

                    {props?.cartVarient?.Product?.variant_type_id ===
                      variant_type.Double && (
                      <>
                        <strong>Type:</strong>{" "}
                        {
                          props?.cartVarient?.Double_Variant?.Product_Variant
                            ?.Metal?.name
                        }
                        , <strong>Size:</strong>{" "}
                        {props?.cartVarient?.Double_Variant?.Size?.name}{" "}
                      </>
                    )}

                    {props?.cartVarient?.Product?.variant_type_id ===
                      variant_type.Triple && (
                      <>
                        <strong>Type:</strong>{" "}
                        {
                          props?.cartVarient?.Triple_Variant?.Double_Variant
                            ?.Product_Variant?.Metal?.name
                        }
                        , <strong>Size:</strong>{" "}
                        {
                          props?.cartVarient?.Triple_Variant?.Double_Variant
                            ?.Size?.name
                        }
                        , <strong> Thickness: </strong>{" "}
                        {props?.cartVarient?.Triple_Variant?.Diamond?.name}
                      </>
                    )}
                    {/* Metal:{" "}
                                      <span>
                                        {props?.cartVarient?.Product_Variant?.Metal?.name ||
                                          props?.cartVarient?.Double_Variant?.Product_Variant
                                            ?.Metal?.name ||
                                          props?.cartVarient?.Triple_Variant?.Double_Variant
                                            ?.Product_Variant?.Metal?.name}
                                      </span> */}
                  </h6>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-7">
              <div className="right_side">
                <IncrementDecrementBtnCart
                  val={props?.cartVarient}
                  quantity={props?.cartVarient?.quantity}
                />

                <div className="delete_btn">
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="delete_icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      openDeleteModal(
                        props?.cartVarient.id,
                        props?.cartVarient.product_id,
                        props?.cartVarient.variant_id,
                      )
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-5">
              <div className="selling_price_div">
                <p className="selling_price">₹{Number(price).toFixed(2)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Remove Product From Cart</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to remove this product from the cart?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>

          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CartProductCard;
